import axios from 'axios';
import { ArticleFeedbackDto } from '../../model/dto/articleFeedbackDto';
import { KnowledgeArticleDto } from '../../model/dto/knowledgeArticleDto';
import { KnowledgeArticlesDto } from '../../model/dto/knowledgeArticlesDto';

interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

class ArticleApi {
  private cache: Map<string, CacheEntry<any>> = new Map();

  private getCacheKey(url: string): string {
    return url;
  }

  private getFromCache<T>(key: string): T | null {
    const entry = this.cache.get(key);
    if (!entry) return null;

    return entry.data as T;
  }

  private setCache<T>(key: string, data: T): void {
    this.cache.set(key, {
      data,
      timestamp: Date.now()
    });
  }

  public clearCache(): void {
    this.cache.clear();
  }
  PostFeedback(articleNumber: string, helpfull: boolean | undefined) {
    let url = `${process.env.REACT_APP_API_URL}/Articles/Feedback?articleNumber=${articleNumber}&feedback=${helpfull}`;

    return axios
      .post(url)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      });
  }
  CreateArticleFeedback = async (dto: ArticleFeedbackDto): Promise<boolean> => {
    let url = `${process.env.REACT_APP_API_URL}/Articles`;

    return axios
      .post(url, dto)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      });
  };

  GetKnowledgeArticles = async (itemsPerPage: number, pageNumber: number, searhTerm: string | null, category?: string, signal?: AbortSignal, lang?: string | undefined, useCache?: boolean): Promise<KnowledgeArticlesDto> => {

    let url = `${process.env.REACT_APP_API_URL}/Articles?itemsPerPage=${itemsPerPage}&pageNumber=${pageNumber}`;

    if (searhTerm)
      url += `&query=${searhTerm}`;

    if (category && category != 'all')
      url += `&category=${category}`;

    if (!!lang)
      url += `&lang=${lang}`;

    // Check cache if useCache is true
    if (useCache) {
      const cachedData = this.getFromCache<KnowledgeArticlesDto>(this.getCacheKey(url));
      if (cachedData) {
        return cachedData;
      }
    }

    return axios
      .get(url, { signal: signal })
      .then((response) => {
        if (response.status === 200) {
          this.setCache(this.getCacheKey(url), response.data);
          return response.data;
        }
      })
  };

  GetKnowledgeArticle = async (articleNumber: string | undefined, articleTitle: string | undefined, embeded?: boolean | undefined, lang?: string | undefined, signal?: AbortSignal, useCache?: boolean): Promise<KnowledgeArticleDto | null> => {
    let url = ''
    if (!!articleNumber) url = `${process.env.REACT_APP_API_URL}/Articles/${articleNumber}?`;
    else if (!!articleTitle) url = `${process.env.REACT_APP_API_URL}/Articles/ByTitle/${articleTitle}?`;

    if (!!embeded) url += `&embedded=${embeded}`;
    if (!!lang) url += `&lang=${lang}`;

    // Check cache if useCache is true
    if (useCache) {
      const cachedData = this.getFromCache<KnowledgeArticleDto>(this.getCacheKey(url));
      if (cachedData) {
        return cachedData;
      }
    }

    return axios
      .get(url, { signal: signal })
      .then((response) => {
        if (response.status === 200) {
          this.setCache(this.getCacheKey(url), response.data);
          return response.data;
        }
        return null;
      })
  };

  GetReleaseNotesArticleNumber = async (useCache?: boolean): Promise<string> => {
    let url = `${process.env.REACT_APP_API_URL}/Articles/ReleaseNotesArticleNumber`;

    // Check cache if useCache is true
    if (useCache) {
      const cachedData = this.getFromCache<string>(this.getCacheKey(url));
      if (cachedData) {
        return cachedData;
      }
    }

    return axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.setCache(this.getCacheKey(url), response.data);
          return response.data;
        }
      });
  };



}

export default new ArticleApi;